import waitTask from '@/common/utils/waitTask';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

function resource({ rootState }, targetGroupId) {
  return getClusterId()
    .then(clusterId => (`/api/v2/${clusterId}/iscsi-alua/target-groups/${targetGroupId || rootState.routes.params.targetGroupId}`));
}

export default {
  namespaced: true,
  getters: {
    getItems: (_state, _getters, rootState, rootGetters) => rootGetters['iscsi/targetGroups/getAllTargets'],
    getItemById: (_state, getters) => id => getters.getItems.find(item => item.id === id),
    getItemByName: (_state, getters) => name => getters.getItems.find(item => item.name === name),
    getItemsByNodeId: (_state, getters) => nodeId => getters.getItems.filter(item => item.node_id === nodeId),
  },
  actions: {
    CREATE_TARGET(store, params) {
      return resource(store)
        .then(resourceStr => this.$api.post(`${resourceStr}/targets/`, params))
        .then(waitTask);
    },
    CREATE_TARGETS({ dispatch }, params) {
      return Promise.all(params.nodes.map(node => dispatch('CREATE_TARGET', node)));
    },
    DELETE(store, { item, force }) {
      const { id, targetGroupId } = item;

      return resource(store, targetGroupId)
        .then(resourceStr => this.$api.delete(`${resourceStr}/targets/${id}`, { force }))
        .then(waitTask);
    },
    DELETE_ITEMS({ dispatch, getters }, { items, force }) {
      return items.reduce((promisesChain, item) => {
        // Additional check for the presence of an element just before the delete request
        // This is necessary to reduce the chance of trying to re-delete already deleted items.
        // This can happen when trying to delete items after errors.
        // Or when used in parallel, because the request can take a very long time
        if (getters.getItemById(item.id)) {
          return promisesChain.then(() => dispatch('DELETE', { item, force }));
        }
        return Promise.resolve();
      }, Promise.resolve());
    },
  }
};
